<div class="py-[30px]">
  @if (!showBookingSettings) {
    <div class="v4-layout-form">
      <div class="v4-layout-form-title">
        {{ "property-property_detail-pricing_html_基础周末价" | translate }}
        <!-- Base & Weekend Price -->
      </div>
      <div class="v4-layout-form-desc">{{ "property-property_detail-pricing_html_基础周末价格说明" | translate }}</div>
      <div class="">
        <!-- <nz-alert
          nzShowIcon
          [nzMessage]="'property-property_detail-pricing_html_基础周末价格说明' | translate"></nz-alert> -->

        <div class="mt-[16px] flex flex-row items-center justify-between">
          <div class="w-[300px] mr-3 h-height-lg"></div>
          <div class="flex flex-row items-center">
            <div class="w-32 mr-6 h-height-lg">
              {{ "property-property_detail-pricing_html_基础价" | translate }}
              <!-- Base price -->
            </div>
            <div class="w-32 mr-6 h-height-lg">
              {{ "property-property_detail-pricing_html_周末价" | translate }}
              <!-- Weekend price -->
            </div>
          </div>
        </div>
        <div class="flex flex-row items-center justify-between">
          <div class="w-[300px] mr-3">
            {{ "property-property_detail-pricing_html_一键改价" | translate }}
            <!-- Quick Modify -->
          </div>
          <div class="flex flex-row items-center">
            <div class="w-32 mr-6">
              <input
                type="text"
                nz-input
                nzSize="large"
                [placeholder]="'property-property_detail-pricing_html_基础价' | translate"
                [(ngModel)]="batchDailyPrice"
                (ngModelChange)="onBatchDailyPriceChange()" />
            </div>
            <div class="w-32 mr-6">
              <input
                type="text"
                nz-input
                nzSize="large"
                [placeholder]="'property-property_detail-pricing_html_周末价' | translate"
                [(ngModel)]="batchWeekendPrice"
                (ngModelChange)="onBatchWeekendPriceChange()" />
            </div>
          </div>
        </div>
        @for (item of prices?.slice(0, showMoreItem() ? prices.length : showMoreItemLimit); track $index) {
          <div class="flex flex-row items-center justify-between mt-3">
            <div class="mr-[30px] flex flex-row items-center flex-1">
              <img class="w-[16px] mr-[8px]" [src]="(item.thirdparty_type | thirdparty)?.icon_color_bg" alt="" />
              <div class="ellipsis-line-2" [title]="item.title">{{ item.title }}</div>
            </div>

            <div class="flex flex-row items-center">
              @for (type of ["daily_price", "weekend_price"]; track $index) {
                <div class="w-32 mr-6">
                  @if (isSupportPrice($any(type), item.thirdparty_type)) {
                    <input
                      type="text"
                      nz-input
                      nzSize="large"
                      [placeholder]="'property-property_detail-pricing_html_' + type | translate"
                      [(ngModel)]="item[type]" />
                  } @else {
                    <input
                      type="text"
                      nz-input
                      nzSize="large"
                      [disabled]="true"
                      placeholder="N/A"
                      nz-tooltip
                      [nzTooltipTitle]="'property-property_detail-pricing_html_' + type + '_unsupport' | translate" />
                  }
                </div>
              }
            </div>
          </div>
        }

        @if (prices?.length > showMoreItemLimit) {
          <div class="mt-3">
            <a href="javascript:void(0)" (click)="showMoreItem.set(!showMoreItem())">{{ showMoreText() }}</a>
          </div>
        }

        <div class="mt-6">
          <button nz-button nzType="primary" nzSize="large" (click)="onSave()">
            {{ "word.save" | translate }}
            <!-- Save -->
          </button>
        </div>
      </div>
    </div>

    <div class="v4-layout-form">
      <div class="v4-layout-form-title">
        {{ "property-property_detail-pricing_html_房间设置" | translate }}
        <!-- Listing Specific Settings -->
      </div>
      <div class="v4-layout-form-desc">
        {{ "property-property_detail-pricing_html_房间设置说明" | translate }}
      </div>

      <div class="v4-layout-block-content">
        <!-- <nz-alert nzShowIcon [nzMessage]="'property-property_detail-pricing_html_房间设置说明' | translate"></nz-alert> -->

        <nz-table
          #nzTable
          class="v4-layout-list"
          [nzFrontPagination]="false"
          [nzData]="listOfHouseSupportSetRules"
          [nzTotal]="total"
          [(nzPageIndex)]="page"
          [nzPageSize]="pageSize"
          nzPaginationType="small"
          [nzShowTotal]="totalTpl"
          (nzPageIndexChange)="onPageChange()">
          <thead>
            <tr>
              <th>{{ "word.house_list" | translate }}</th>
            </tr>
          </thead>
          <tbody class="v4-layout-list-body">
            <tr class="cursor-pointer" (click)="onClickHouse(house)" *ngFor="let house of nzTable.data">
              <td>
                <div class="flex flex-row items-center">
                  <div class="relative mr-2">
                    <img
                      class="absolute left-1 top-1 w-[18px] h-[18px] rounded-full"
                      [src]="(house.thirdparty_type | thirdparty)?.icon_color_bg"
                      alt="" />
                    <span class="absolute right-1 top-1 count">{{ house.inventory }}</span>
                    <img
                      class="w-20 h-14 rounded-[10px]"
                      src="/assets/status/placeholder.png"
                      hostPlaceholder
                      [delaySrc]="house?.picture?.small_url"
                      alt="" />
                  </div>
                  <div>{{ house.title }}</div>
                </div>
              </td>
            </tr>
          </tbody>
        </nz-table>
        <ng-template #totalTpl>
          {{ "component-page_html_总数" | translate: { number: total } }}
          <!-- {{ total }} items -->
        </ng-template>
      </div>
    </div>
  } @else {
    <div class="flex flex-row items-center mb-12">
      <i nz-icon nzType="left" nzTheme="outline" class="mr-2 cursor-pointer" (click)="showBookingSettings = false"></i>
      <nz-select class="w-[200px]" [(ngModel)]="currentHouse" [nzCustomTemplate]="selectTpl">
        <nz-option
          *ngFor="let house of listOfHouseSupportSetRules"
          [nzValue]="house"
          [nzLabel]="house.title"></nz-option>
      </nz-select>
      <ng-template #selectTpl let-selected>
        <div class="flex flex-row items-center">
          <img
            [src]="(selected.nzValue?.thirdparty_type | thirdparty)?.icon_color"
            alt=""
            class="w-[18px] h-[18px] rounded-full mr-2" />
          <span>{{ selected.nzLabel }}</span>
        </div>
      </ng-template>
    </div>
    <property-detail-booking-settings [house]="currentHouse"></property-detail-booking-settings>
  }
</div>
